import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import PSTablePolicies from '../../components/molecules/PSTablePolicies/PSTablePolicies';
import FaqSection from '../../components/molecules/PSFaqSection/PSFaqSection';
import TokenAuthorization from '../../shared/services/TokenAuthorization';
import PSGlobalLoading from '../../components/PSGlobalLoading';
import LifeInvestmentService from '../../shared/services/LifeInvestmentService';
import { getFaqs, setGraphicalData } from '../../redux/auth';
import PSIcon from '../../components/PSIcon';

import './index.scss';
import { showErrorToast } from '../../../util/Constant';

export default function HomeProductVidaIndividual() {
  const { userInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);

  const monthNames = [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre',
  ];

  const getDocumentType = (documentType) => {
    switch (documentType) {
      case 'L':
        return '2';
      case 'R':
        return '1';
      case 'E':
        return '4';
      default:
        return '2';
    }
  };

  const getTokenPD = async () => {

    try{

      const sessionPD = localStorage.getItem('sessionPD');

      if (!sessionPD) {
      setIsLoading(true);
      const responseTest = await TokenAuthorization.loginToken180();

      if(responseTest.status == "ok"){

            localStorage.setItem('sessionPD', true);
            getAllServices();

        }else{
            setIsLoading(false);
            showErrorToast("Error al consultar Polizas");
        }
      }
    }catch(error){
      showErrorToast("Error al consultar Polizas");
      localStorage.removeItem('sessionPD');
      setIsLoading(false);
    }
  };

  const getAllServices = async () => {
    try {
      const payloadPolicies = {
        documentType: getDocumentType(userInfo.documentType),
        documentNumber: userInfo.document,
      };

      const payloadFaqs = {
        origen: 1,
        ramo: 71,
        idProducto: 6,
      };

      const [
        responseEmitter,
        responseSector,
        responseInstrument,
        responseQuoteEvolution,
        responsePolicies,
        responseFaqs,
      ] = await Promise.all([
        LifeInvestmentService.getEmitterGraph(),
        LifeInvestmentService.getSectorGraph(),
        LifeInvestmentService.getInstrumentGraph(),
        LifeInvestmentService.getQuoteEvolutionValue(),
        LifeInvestmentService.getPoliciesVigp(),
        LifeInvestmentService.getFaqs(),
      ]);

      console.log("RESPONSE EMITTER" , responseEmitter);

      const newGraphicalDataSets = {
        emitter: {
          items: responseEmitter.emisores.map((item, index) => ({
            id: index,
            nombre: item.emisor,
            porcentajeParticipacion: item.porcentajeParticipacion,
            montoTotal: item.montoTotal,
          })),
        },
        economicSector: {
          items: responseSector.sectores.map((item, index) => ({
            id: index,
            nombre: item.sectorEconomico,
            porcentajeParticipacion: item.porcentajeParticipacion,
            montoTotal: item.montoTotal,
          })),
        },
        instrument: {
          items: responseInstrument.instrumentos.map((item, index) => ({
            id: index,
            nombre: item.tipoInstrumento,
            porcentajeParticipacion: item.porcentajeParticipacion,
            montoTotal: item.montoTotal,
          })),
        },
      };

      const newDataQuoteEvolution = responseQuoteEvolution.valoresCuota
        ?.map((item) => ({
          ...item,
          mes: monthNames[parseInt(item.mes, 10) - 1],
        }))
        .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
        .slice(-8);
        
        console.log(responsePolicies);

      const newDataPolicies = responsePolicies?.policies?.polizas.sort(
        (a, b) => new Date(b.fechaOrigen) - new Date(a.fechaOrigen)
      );

      dispatch(setGraphicalData(newGraphicalDataSets));
      dispatch(getFaqs(responseFaqs?.preguntasRespuestas));
      localStorage.setItem('quoteEvolution', JSON.stringify(newDataQuoteEvolution));
      localStorage.setItem('policiesVigp', JSON.stringify(newDataPolicies));
      setIsLoading(false);
    } catch (error) {
      console.error('Error al obtener data:', error);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    getTokenPD();
      //iniciar sesion getToken!
    localStorage.removeItem('dataFund');
    localStorage.removeItem('policyDetail');
    localStorage.removeItem('dataCoverage');
  }, []);

  return (
    <>
      <div className="home-vidaInversion__container">
        {isLoading && <PSGlobalLoading show={isLoading} />}
        <div className="home-vidaInversion__container--header">
          <div className="breadcrumb">
            <Link to="/intranet" className="breadcrumb-link">
              <PSIcon type="homeGray" className="breadcrumb-icon" />
              <span>Mis seguros</span>
            </Link>
            <div className="breadcrumb-separator">
              <PSIcon type="arrowRightOrange" className="arrow" />
            </div>
            <span className="breadcrumb-current">Vida Inversión Global Protecta</span>
          </div>
          <h1>Vida Inversión Global Protecta</h1>
          <p>
            Aquí encontrará el detalle de su póliza y rentabilidad a través de inversiones
            internacionales.
          </p>
        </div>
        <div className="home-vidaInversion__container--policies">
          <PSTablePolicies />
        </div>
      </div>
      <div className="home-vidaInversion__faqs">
        <FaqSection />
      </div>
    </>
  );
}
